import {debugLog} from "../Utils/LogUtils";
import {PLAN_TYPE_IDS} from "../Utils/PlanUtils";
import {useEffect} from "react";

//Force units to be 1.000 for SI and Achievers plans
const useUpdateUnitsBasedOnPlanType = (state) => {
    /*
    useEffect(() => {
        let setUnits = state.plan.numberOfUnits;
        if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS || state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
            setUnits = 1;
        }
        if (state.plan.numberOfUnits !== setUnits) {
            state.setPlan({
                ...state.plan,
                numberOfUnits: setUnits
            });
        }
        debugLog("useUpdateUnitsBasedOnPlanType");
    }, [state.plan.planTypeID]);

     */
}

export default useUpdateUnitsBasedOnPlanType;